import { getRequest, postRequest } from 'services/requests';

export default {
    createStudents: (body) => postRequest('/admin/create-students', body),
    createInstructors: (body) => postRequest(`/admin/create-instructors`, body),
    findCourse: (body) => postRequest(`/admin/find-course`, body),
    findUser: (body) => postRequest(`/admin/find-user`, body),
    listUsers: (body) => postRequest(`/admin/list-users`, body),
    listStudents: (body) => postRequest(`/admin/list-students`, body),
    updateUser: (body) => postRequest(`/admin/update-user`, body),
    studentDeactivate: (body) => postRequest(`/admin/student-deactivate`, body),
    studentActivate: (body) => postRequest(`/admin/student-activate`, body),
    createCourse: (body) => postRequest(`/admin/create-course`, body),
    listAllUsers: () => postRequest(`/admin/list-all-users`),
    listAllCourses: () => getRequest(`/admin/list-all-courses`),
};
